// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Jz_y","name":"ConsentHeader_name__KEE7s","birthday":"ConsentHeader_birthday__2A0vl","skeleton":"ConsentHeader_skeleton__rGvQD"};